import React from 'react'

function Services() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Services
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Services
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Service Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Services
            </h6>
            <h1 className="mb-5">Our Services</h1>
          </div>
          <div className="row g-4">
            {/* Card 1 - Accommodation */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-hotel text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Premium Accommodation</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Quality hotels/resorts with AC/non-AC rooms (as per package).
                    24-hour security, cleanliness, hot water, and generator facilities included.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 - Mid-Range Stays */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-bed text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Mid-Range Stays</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Comfortable and clean accommodations with all basic amenities.
                    Safe environment with regular room service and maintenance.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 - Daily Meals */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-utensils text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Daily Meals</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Breakfast, lunch and dinner included. Local traditional cuisine
                    (seafood in Cox's Bazar, local chicken in Sundarbans) served.
                    Bottled drinking water provided.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 - Transportation */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-bus text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Transportation</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Luxury AC/non-AC bus or train tickets from Dhaka/Khulna.
                    Local transport includes microbuses, Chandor Gari, speedboats.
                    Airport/station pickup and drop facility.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 5 - Sightseeing Tours */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-binoculars text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Sightseeing Tours</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Visit all major tourist spots according to package duration
                    (like Saint Martin's Chera Dwip, Cox's Bazar's Inani).
                    All entry fees and parking charges included.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 6 - Travel Guides */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-user text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Expert Travel Guides</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Trained tour guides with knowledge of local culture and history.
                    Professional assistance throughout the tour for better experience.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 7 - Emergency Support */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-phone text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>24/7 Emergency Support</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Round-the-clock phone support. First aid kit available.
                    Arrangement for hospital transfer in emergencies.
                    Constant communication support.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 8 - Event Management */}
            <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
              <div className="service-item rounded pt-3" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease'
              }}>
                <div className="p-4" style={{ flex: '1 0 auto' }}>
                  <i className="fa fa-3x fa-cog text-primary mb-4" />
                  <h5 style={{ minHeight: '48px', marginBottom: '10px' }}>Event Management</h5>
                  <p style={{
                    marginBottom: '0',
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '5',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    Professional event planning and management services for
                    corporate events, weddings, and special occasions during tours.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}

      {/* Testimonial Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Testimonial
            </h6>
            <h1 className="mb-5">Our Clients Say!!!</h1>
          </div>
          <div className="owl-carousel testimonial-carousel position-relative">
            <div className="testimonial-item bg-white text-center border p-4">
              <img
                className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
                src="assets/img/testimonial-1.jpg"
                style={{ width: 80, height: 80 }}
                alt="Client"
              />
              <h5 className="mb-0">John Doe</h5>
              <p>New York, USA</p>
              <p className="mb-0">
                Excellent accommodation and food services. The transportation was comfortable
                and the guides were very knowledgeable about local culture.
              </p>
            </div>
            <div className="testimonial-item bg-white text-center border p-4">
              <img
                className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
                src="assets/img/testimonial-2.jpg"
                style={{ width: 80, height: 80 }}
                alt="Client"
              />
              <h5 className="mb-0">Sarah Smith</h5>
              <p>London, UK</p>
              <p className="mt-2 mb-0">
                The 24/7 support was amazing! Had a minor issue and they resolved it immediately.
                Highly recommended for worry-free travel.
              </p>
            </div>
            <div className="testimonial-item bg-white text-center border p-4">
              <img
                className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
                src="assets/img/testimonial-3.jpg"
                style={{ width: 80, height: 80 }}
                alt="Client"
              />
              <h5 className="mb-0">David Brown</h5>
              <p>Sydney, Australia</p>
              <p className="mt-2 mb-0">
                The sightseeing package covered all major attractions. Food was delicious
                with local flavors. Great value for money!
              </p>
            </div>
            <div className="testimonial-item bg-white text-center border p-4">
              <img
                className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
                src="assets/img/testimonial-4.jpg"
                style={{ width: 80, height: 80 }}
                alt="Client"
              />
              <h5 className="mb-0">Maria Garcia</h5>
              <p>Madrid, Spain</p>
              <p className="mt-2 mb-0">
                Event management service was outstanding! They organized our corporate retreat
                seamlessly along with the tour package.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Testimonial End */}
    </div>
  )
}

export default Services